export default {
    titulo: "Informes",
    reparaciones: "Reparaciones en taller",
    detalle: "Información detallada",
    tipoMarcaModelo: "Por tipo, marca y modelo",
    servicios: "Servicios en terreno",
    tipoArea: "Por tipo y por área",
    gestion: "Indicadores de gestión",
    fallas: "Servicios por fallas",
    stock: "Stock",
    compras: "Compras",
    costos: "Costos de materiales por familia",
    consumo: "Consumo de materiales en mantenimiento",
    repuestos: "Repuestos utilizados en órdenes",
    satisfaccion: "Satisfacción del cliente",
    encuesta: "Encuestas de satisfacción",
    productividad: "Productividad",
    comisiones: "Comisiones por técnico", 
    estadisticasServ: "Estadísticas de servicios",
    estadisticasRep: "Estadísticas de reparaciones",
    ordenarPor: "Ordenar por",
    nroOrden: "Nro. de orden",
    ingreso: "De ingreso",
    fin: "De finalización",
    entrega: "De entrega",
    tituloCompras: "Informe de compras",
    tituloComisiones: "Informe de comisiones por técnico",
    tituloCostos: "Informe de costos de materiales por familia",
    tituloEncuestas: "Informe de encuestas de satisfacción",
    aplicada: "Aplicada a ",
    opcionRep: "Órdenes de reparación",
    opcionServ: "Órdenes de servicio",
    repYserv: "Órdenes de reparación y servicio",
    seleccionarCliente: "Seleccionar un cliente",
    clienteSeleccionado: "Cliente seleccionado",
    tituloServ: "Informe de servicios",
    tituloRep: "Informe de reparaciones",
    estados: "Estados",
    notificado: "Notificado",
    noNotificado: "No notificado",
    entregado: "Entregado",
    finalizado: "Finalizado",
    tituloRepuestos: "Informe de repuestos utilizados en órdenes",
    tituloTipoArea: "Informe de servicios por tipo y área",
    eficacia: "Eficacia",
    aTiempo: "A tiempo",
    tarde: "Tarde"

}